import { each } from 'lodash'

import Preloader from 'components/Preloader'
import AgeCheck from 'components/AgeCheck'
import Header from 'components/Header'
import Availability from 'components/Availability'
import Navigation from 'components/Navigation'
import MiniCart from './components/MiniCart'

import Home from 'pages/Home'
import Pocinho from 'pages/Pocinho'
import Experiences from 'pages/Experiences'
import Accomodations from 'pages/Accomodations'
import Rooms from 'pages/Rooms'
import Villas from 'pages/Villas'
import Wines from 'pages/Wines'
import Contacts from 'pages/Contacts'
import SingleProduct from 'pages/SingleProduct'
import BookingSearch from 'pages/BookingSearch'
import BookingConfirmation from 'pages/BookingConfirmation'
import Press from 'pages/Press'
import Default from 'pages/Default'
import Cart from 'pages/Cart'
import Page404 from 'pages/Page404'
import Gallery from 'pages/Gallery'

class App {
  constructor() {
    this.createBeforeContent()

    this.createContent()

    this.createNavigation()
    this.createComponents()

    this.createPages()

    if (!window.sessionStorage.getItem('doNotShow')) {
      this.createPreloader()
      window.sessionStorage.setItem('doNotShow', 'true')
    } else {
      this.preloader = new Preloader()
      this.onPreloaded()
    }

    this.addEventListeners()

    // this.checkLinks()

    this.update()

    this.logo = document.querySelector('.logo_link')
  }

  createPreloader() {
    this.preloader = new Preloader()
    this.body = document.body

    this.body.style.overflow = 'hidden'
    this.preloader.once('completed', this.onPreloaded.bind(this))
  }

  createNavigation() {
    this.navigation = new Navigation({
      template: this.template
    })
  }

  createComponents() {
    this.components = {
      header: new Header(),
      availability: new Availability(),
      minicart: new MiniCart(),
      ageChecke: new AgeCheck()
    }
  }

  createBeforeContent() {
    this.content = document.querySelector('.content')
    this.name = this.content.getAttribute('data-name')
    this.wrapper = document.querySelector('.wrapper')
    this.wrapper.setAttribute('data-template', this.name)
  }

  createContent() {
    this.template = this.wrapper.getAttribute('data-template')
  }

  createPages() {
    this.pages = {
      home: new Home(),
      pocinho: new Pocinho(),
      rooms: new Rooms(),
      villas: new Villas(),
      experiences: new Experiences(),
      accomodations: new Accomodations(),
      wines: new Wines(),
      contacts: new Contacts(),
      singleProduct: new SingleProduct(),
      bookingSearch: new BookingSearch(),
      bookingConfirmation: new BookingConfirmation(),
      press: new Press(),
      default: new Default(),
      pageCart: new Cart(),
      gallery: new Gallery(),
      page404: new Page404()
    }

    this.page = this.pages[this.template]

    this.page.create()

    if (this.template === 'singleProduct') {
      document.querySelector('.availability').style.display = 'none'
    } else {
      document.querySelector('.cart_button').style.display = 'none'
    }

    this.onResize()
  }

  onPreloaded() {
    this.preloader.destroy()
    this.page.show()
  }

  async onChange(url) {
    await this.navigation.menuClose()
    await this.page.hide()

    const request = await window.fetch(url)

    if (request.status === 200) {
      const html = await request.text()
      const div = document.createElement('div')

      div.innerHTML = html

      const divContent = div.querySelector('.wrapper')

      this.contentname = div.querySelector('.content')

      this.changename = this.contentname.getAttribute('data-name')

      this.template = this.changename

      this.wrapper.innerHTML = divContent.innerHTML

      this.page = this.pages[this.changename]

      this.checkLinks()

      this.page.create()

      this.onResize()

      this.page.show()
    } else {
      console.log('Error')
    }
  }

  onResize() {
    if (this.page && this.page.onResize) {
      this.page.onResize()
    }
  }

  update() {
    if (this.page && this.page.update) {
      this.page.update()
    }
    this.frame = window.requestAnimationFrame(this.update.bind(this))
  }

  addEventListeners() {
    window.addEventListener('resize', this.onResize.bind(this))
  }

  addLinkListeners() {
    const links = document.querySelectorAll('a')
    const submit = document.querySelector('.wpcf7-form-control')

    each(links, link => {
      link.onclick = event => {
        const { href } = link

        // event.preventDefault()

        if (link !== '#') { this.onChange(href) }
      }
    })

    if (submit) {
      submit.onclick = event => {
      }
    }
  }

  removeLinkListeners() {
    const links = document.querySelectorAll('a')
    // const submit = document.querySelectorAll('button[type="submit"]')
    const submit = document.querySelector('.wpcf7-form-control')

    each(submit, button => {
      submit.onclick = event => {
        // event.preventDefault()
      }
    })

    each(links, link => {
      link.onclick = event => {
        // event
      }
    })
  }

  checkLinks() {
    if (this.template !== 'bookingConfirmation' && this.template !== 'singleProduct') {
      this.addLinkListeners()
    } else {
      this.removeLinkListeners()
    }
  }
}

new App()
